<div class="row g-3" appVisible [visible$]="visible$">
  @if ((data$ | async) !== undefined && !loading && !error) {
    <div class="col-12">
      <app-card>
        <div class="overview-card w-100">
          @if (message) {
            <div class="info-overlay border rounded p-3 text-center">
              <span>{{ message }}</span>
            </div>
          } @else {
            <div class="table-responsive">
              <table class="table table-hover align-middle mb-0 overview-table">
                <thead>
                  <tr>
                    <th scope="col"><i class="bi bi-geo-alt me-2" aria-hidden="true"></i>Locatie</th>
                    <th scope="col" class="text-center">
                      <i class="bi bi-activity me-2" aria-hidden="true"></i>Afwijkers
                    </th>
                    <th scope="col" class="text-end">
                      <i class="bi bi-door-open me-2" aria-hidden="true"></i>Gemeten ruimtes
                    </th>
                  </tr>
                </thead>
                <tbody>
                  @for (item of items; track item.entityId) {
                    <tr
                      class="overview-row"
                      [routerLink]="['/klimaat']"
                      [queryParams]="{ objecten: item.entityId, periode: 'live' }"
                      tabindex="0"
                      role="link"
                    >
                      <td>
                        <div class="location-cell">
                          <span class="location-marker"><i class="bi bi-pin-map" aria-hidden="true"></i></span>
                          <span class="location-copy">
                            <span class="overview-item-name">{{ item.name }}</span>
                            @if (item.path) {
                              <small class="text-muted d-block">{{ item.path }}</small>
                            }
                          </span>
                          <i class="bi bi-arrow-up-right text-primary" aria-hidden="true"></i>
                        </div>
                      </td>
                      <td class="text-center">
                        @if (item.deviatingRoomIds?.[0]; as deviatingRoomId) {
                          <a
                            class="text-reset"
                            [routerLink]="['/klimaat']"
                            [queryParams]="{ objecten: deviatingRoomId, periode: 'live' }"
                            (click)="$event.stopPropagation()"
                          >
                            <span class="badge badge-soft bg-danger text-danger">
                              {{ item.deviations ?? 0 }}
                            </span>
                          </a>
                        } @else {
                          <span
                            class="badge badge-soft"
                            [class.bg-success]="(item.deviations ?? 0) === 0"
                            [class.text-success]="(item.deviations ?? 0) === 0"
                            [class.bg-danger]="(item.deviations ?? 0) > 0"
                            [class.text-danger]="(item.deviations ?? 0) > 0"
                          >
                            {{ item.deviations ?? 0 }}
                          </span>
                        }
                      </td>
                      <td class="text-end text-nowrap">
                        <strong class="spaces-value">{{ item.measuredSpaces ?? 0 }}</strong>
                        <span class="text-muted"> ruimtes</span>
                      </td>
                    </tr>
                  } @empty {
                    <tr>
                      <td [attr.colspan]="3" class="text-center">Geen gegevens beschikbaar</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
      </app-card>
    </div>
  }

  @if (loading && !message) {
    <div class="col-12">
      <app-card>
        <div class="overview-card placeholder-glow">
          <div class="table-responsive">
            <table class="table align-middle mb-0 overview-table" aria-hidden="true">
              <thead>
                <tr>
                  <th scope="col">Locatie</th>
                  <th scope="col" class="text-center">Afwijkers</th>
                  <th scope="col" class="text-end">Gemeten ruimtes</th>
                </tr>
              </thead>
              <tbody>
                @for (row of [1, 2, 3]; track row) {
                  <tr>
                    <td>
                      <span class="placeholder col-7"></span>
                      <span class="placeholder col-5 d-block mt-1"></span>
                    </td>
                    <td class="text-center"><span class="placeholder col-3"></span></td>
                    <td class="text-end"><span class="placeholder col-7"></span></td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </app-card>
    </div>
  }
</div>
